/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { ReferralLevel, ReferralLevelFromJSON, ReferralLevelFromJSONTyped, ReferralLevelToJSON } from './ReferralLevel'

/**
 *
 * @export
 * @interface UserFarmingLevelResponse
 */
export interface UserFarmingLevelResponse {
  /**
   *
   * @type {ReferralLevel}
   * @memberof UserFarmingLevelResponse
   */
  currentLevel?: ReferralLevel
  /**
   *
   * @type {string}
   * @memberof UserFarmingLevelResponse
   */
  nextLevel?: string
  /**
   *
   * @type {Array<number>}
   * @memberof UserFarmingLevelResponse
   */
  farmingLevelProgress?: Array<number>
}

export function UserFarmingLevelResponseFromJSON(json: any): UserFarmingLevelResponse {
  return UserFarmingLevelResponseFromJSONTyped(json, false)
}

export function UserFarmingLevelResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UserFarmingLevelResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    currentLevel: !exists(json, 'currentLevel') ? undefined : ReferralLevelFromJSON(json['currentLevel']),
    nextLevel: !exists(json, 'nextLevel') ? undefined : json['nextLevel'],
    farmingLevelProgress: !exists(json, 'farmingLevelProgress') ? undefined : json['farmingLevelProgress'],
  }
}

export function UserFarmingLevelResponseToJSON(value?: UserFarmingLevelResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    currentLevel: ReferralLevelToJSON(value.currentLevel),
    nextLevel: value.nextLevel,
    farmingLevelProgress: value.farmingLevelProgress,
  }
}
